// extracted by mini-css-extract-plugin
export default {"root":"Header_root__jiUBv","inner":"Header_inner__jb7a0","buttons":"Header_buttons__qrm31","title":"Header_title__l+wMf","logo":"Header_logo__shVBB"};